import { render, staticRenderFns } from "./Filters.vue?vue&type=template&id=48441a38&scoped=true&"
import script from "./Filters.vue?vue&type=script&lang=js&"
export * from "./Filters.vue?vue&type=script&lang=js&"
import style0 from "./Filters.vue?vue&type=style&index=0&id=48441a38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48441a38",
  null
  
)

export default component.exports